var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.item)?_c('div',{staticClass:"Show"},[_c('page-section',{attrs:{"title":_vm.item.name,"backLink":true}},[_c('h5',{staticClass:"mt-5 text-left font-weight-semibold font-size-17"},[_vm._v(" Lista Utenti ")]),(_vm.item)?_c('users-list',{attrs:{"companyId":_vm.item.id,"filter":_vm.filter}}):_vm._e()],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }